import { useSelector } from "react-redux";
import {
  POST_STATUS_DRAFT,
  POST_STATUS_LABELS,
  POST_STATUS_PROPOSED_BY_EXTERNAL_USER,
  POST_STATUS_READY,
  POST_STATUS_WAITING_FOR_APPROVAL,
} from "../../config/constants";
import { useTranslate } from "@tolgee/react";

export default function PostStatusBadge() {
  const { post_status, has_been_published } = useSelector(
    (state: any) => state.lomavisCreator
  );
  const { t } = useTranslate();
  const postStatusClass = {
    [POST_STATUS_DRAFT]: "badge-warning",
    [POST_STATUS_WAITING_FOR_APPROVAL]: "badge-info",
    [POST_STATUS_READY]: "badge-primary",
    null: "badge-secondary",
  };
  const getPostStatusLabelAndClass = () => {
    if (post_status == POST_STATUS_READY && has_been_published) {
      return {
        label: t("lomavisCreator.postStatusBadges.published"),
        class: "badge-success",
      };
    } else if (post_status == POST_STATUS_READY) {
      return {
        label: t("lomavisCreator.postStatusBadges.planned"),
        class: "badge-primary",
      };
    } else if (post_status == POST_STATUS_PROPOSED_BY_EXTERNAL_USER) {
      return {
        label: t("lomavisCreator.postStatusBadges.new"),
        class: "badge-secondary",
      };
    } else {
      return {
        label: t(
          "lomavisCreator.postStatusBadges." + POST_STATUS_LABELS[post_status]
        ),
        class: postStatusClass[post_status],
      };
    }
  };
  const { label, class: badgeClass } = getPostStatusLabelAndClass();
  return (
    <div
      className={`position-absolute  badge  ${badgeClass} `}
      style={{ zIndex: 99, top: -2, left: -2 }}
    >
      {label}
    </div>
  );
}
